import React from "react";
import { sanitizeHtml } from "../../../../utils/sanitize";

const CardText = ({ text }) => {
  return <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }} />;
};

export default CardText;
